
import Productdetail from './Product';


export const Productdetails = ({ setArray, array }) => {

  const additemtocart = (shoelist) => {
    let check = array.filter((idd) => idd.id !== shoelist.id);
    console.log(check);
    setArray([...array, shoelist])
  }



  return (
    <div>
      <div className='sidespace'>
        <div className='row'>
          <h2 className='productpagetext'>Get What Fits You</h2>
          {
            Productdetail.map((shoes) =>
              <div className='col-lg-4 d-flex justify-content-center'>
               <div className='card productbox'>
                {/* <div className=''> */}
                <img src={shoes.Image} class="card-img-top shoeimg" alt="..." data-aos="flip-right"
                    data-aos-easing="ease-out-cubic"
                    data-aos-duration="2000" />
                  <div class="card-body">
                    <h5 class="card-title shoenametext">{shoes.shoename}</h5>
                    <div className='pricecart'>
                      <p class="card-text priceamttext">{"MRP : ₹ "}{shoes.price}</p>

                      <button className='cartboxedit' onClick={() => additemtocart(shoes)} >Add To Cart</button>


                    </div>

                  </div>
                {/* </div> */}
              
               </div>
                 

               
              </div>


            )}

        </div>
      </div>
      <section className='footerbox'>
        <div className='sidespace'>
          <div className='rowflex'>
            <div>
              <img src="./images/jordanlogo.png" alt="" className='footerlogo' />
              <p className='footerpara'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia, saepe dolor. Exercitationem commodi eveniet accusantium deserunt ex cumque. ter impedit atque consectetur </p>
              <p className='mailheading'>Receive mail at your mail</p>
              <div className='inputflex'>
                <input type="text" placeholder='Mail id' className='inputbox' />
                <button className='sendbox'>Send</button>
              </div>

            </div>
            <div>
              <h5 className='secondrow'>Products</h5>
              <p className='footersecondrow'>Running shoe</p>
              <p className='footersecond'>Sports shoe</p>
              <p className='footersecond'>Formal shoe</p>
              <p className='footersecond'>Causal shoe</p>
              <p className='footersecond'>Sneakers shoe</p>
            </div>
            <div>
              <h5 className='secondrow'>Support</h5>
              <p className='footersecondrow'>Privacy Policy</p>
              <p className='footersecond'>Terms & Condition</p>
              <p className='footersecond'>Cookies settings</p>
              <p className='footersecond'>Contact us</p>
              <p className='footersecond'>Customer care</p>


            </div>
            <div>
              <h5 className='secondrow'>Contacts</h5>
              <div className='phoneflex'>
                <p class='bx bx-phone-call footerphone' ></p>
                <p className='footernumber'> +99 98564 63277</p>
              </div>
              <div className='mailflex'>
                <p class='bx bx-envelope footerphone' ></p>
                <p className='footernumber'> shoelace@gmail.com</p>
              </div>
              <div className='mailflex'>
                <p class='bx bx-map footerphone' ></p>
                <p className='footernumber'> 27 B benseroad <br />Newyork USA</p>
              </div>
            </div>
          </div>
          <hr className='footerline' />
          <div className='downfooterflex'>
            <div className='dfone'>
              <img src="./images/paymentcard.png" alt="" className='paymentone' />
              <p className='copyright'>Copyright@Dpdesigner/2023</p>
            </div>
            <div className='dftwo'>
              <img src="./images/smtwo.png" alt="" className='paymenttwo' />
              <p className='copyright'>All Rights Reserved</p>
            </div>
          </div>


        </div>
      </section>
    </div>


  )
}
